import React from 'react';

import { RelatedPost } from '../../lib/types/post.types';
import RelatedCard from './cards/related-card';

type RelatedPostsProps = {
  posts: RelatedPost[];
};

const RelatedPosts = ({ posts }: RelatedPostsProps) => {
  return (
    <div className='my-4'>
      <h3 className='text-xl my-4'>Related Posts:</h3>
      <section className='flex flex-wrap justify-between gap-5'>
        {posts.map((post, idx) => {
          return <RelatedCard post={post} key={post.id} />;
        })}
      </section>
    </div>
  );
};
export default RelatedPosts;
